import { Panel } from "primereact/panel";
import FacultyFilter from "../../components/filters/FacultyFilter";
import SpecialityFilter from "../../components/filters/SpecialityFilter";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import { useAppDispatch } from "../../hooks/redux";
import { clearPlansFilters, getPlansFiltersCount, getSelectedFaculties, getSelectedSpecialities, setSelectedFaculties, setSelectedSpecialities } from "../../services/plans/plansSlice";

const ContextSidebar = (props: any) => {
  const plansFiltersCount = useSelector(getPlansFiltersCount);
  const dispatch = useAppDispatch();

  const handleClearFilters = () => {
    dispatch(clearPlansFilters());
  };

  return (
    <Panel
      header="Филтриране на учебни планове"
      className="w-full mt-4 shadow-4"
      pt={{
        header: {
          className: "text-xl surface-ground font-light",
        },
      }}
      {...props}
    >
      {plansFiltersCount > 0 ? (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">{plansFiltersCount} активни филтъра.</p>
          <Button
            label="Изчисти филтрите"
            icon="pi pi-times"
            severity="danger"
            outlined
            size="small"
            className="w-50 mb-4"
            onClick={handleClearFilters}
          />
        </div>
      ) : (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">Няма активни филтри.</p>
          <div className="pi pi-sparkles pi-spin"></div>
        </div>
      )}
      <FacultyFilter getSelectedFaculties={getSelectedFaculties} setSelectedFaculties={setSelectedFaculties} />
      <SpecialityFilter getSelectedSpecialities={getSelectedSpecialities} setSelectedSpecialities={setSelectedSpecialities} />
    </Panel>
  );
};

export default ContextSidebar;
